// extracted by mini-css-extract-plugin
export default {"image":"xW-z","loaded":"yW-z"};